export const faqItems = [
  {
    pergunta: 'O app serve para quais tipos de artesanato?',
    resposta: 'O Artesã foi feito para bordado, tricô, crochê, costura criativa, macramê, punch needle, tapeçaria, quilting, ponto cruz e outras técnicas manuais. Cada forma de criar tem seu espaço aqui.',
  },
  {
    pergunta: 'Qual a diferença entre Light, Pro e Avançado?',
    resposta: 'O Light é gratuito e oferece registro de projetos e sessões de tempo. O Pro traz acompanhamento mais profundo, com cronômetro, gráficos e histórico detalhado. O Avançado inclui gestão de encomendas, clientes, precificação e relatórios.',
  },
  {
    pergunta: 'Posso começar gratuitamente?',
    resposta: 'Sim! O plano Light é totalmente gratuito. Você pode registrar projetos, sessões e acompanhar o tempo investido sem pagar nada.',
  },
  {
    pergunta: 'O app serve para quem faz por hobby?',
    resposta: 'Sim. O Artesã é para todos que criam com as mãos, seja por hobby, para presentear ou como trabalho. O plano Light é ideal para quem quer começar a organizar seus projetos de forma simples.',
  },
  {
    pergunta: 'O app também ajuda quem vende?',
    resposta: 'Sim. O plano Avançado foi pensado para quem vende artesanato e precisa organizar encomendas, clientes, custos e precificação com mais estrutura.',
  },
  {
    pergunta: 'Onde acompanho meus projetos?',
    resposta: 'Depois de criar sua conta, todos os seus projetos ficam acessíveis no painel do Artesã, com informações sobre status, sessões e tempo investido.',
  },
  {
    pergunta: 'Existe suporte?',
    resposta: 'Sim. Você pode entrar em contato pela página de contato ou pela área de ajuda dentro do app. Estamos disponíveis para ajudar com dúvidas sobre o sistema e os planos.',
  },
  {
    pergunta: 'Como funciona a parte de encomendas?',
    resposta: 'No plano Avançado, você pode cadastrar encomendas vinculadas a projetos, acompanhar prazos e status, e manter o histórico de entregas organizado.',
  },
];
